import React from 'react';
import GoogleReviewCard from '../cards/GoogleReviewCard';
import Button from '../common/Button';
import { googleReviews } from '../../data/reviews';
import { URLS } from '../../data/constants';
import './GoogleReviews.css';

const GoogleReviews = () => {
  return (
    <section className="greviews">
      <div className="wrap">
        <div className="sechead">
          <span className="kicker">Direto do Google</span>
          <h2>40 clientes. 40 cinco estrelas.</h2>
          <p>Não somos nós dizendo que somos bons. São eles.</p>
        </div>
        <div className="gcards">
          {googleReviews.map((review) => (
            <GoogleReviewCard key={review.id} review={review} />
          ))}
        </div>
        <p style={{ textAlign: 'center', marginTop: '30px' }}>
          <Button href={URLS.whatsapp} variant="secondary">
            Ver todas as avaliações no Google
          </Button>
        </p>
      </div>
    </section>
  );
};

export default GoogleReviews;
